import * as React from "react";
import EditDriveSignal from "../../Editing/EditDriveSignal";
import Table from "../../../components/Table/Table";
import { editActions } from "../../../actions/editActions";
import { setDriveSignalExtraProperties } from "../../../utils/pdApiUtils";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type DriveSignalsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
  toggleModal: () => void;
  subMenuRoute: State.DriveSubmenu;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.DriveSubmenu, columnFilter: Filter[]) => void;
};

type DriveSignalsTableState = {
  isModalOpen: boolean;
};

export class DriveSignalsTable extends React.Component<
  DriveSignalsTableProps,
  DriveSignalsTableState
> {
  state = {
    isModalOpen: false
  };
  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };
  
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal } = this.props;
    const { signals } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    const driveSignalRows: Api.DriveSignal[] = signals.map(row =>
      setDriveSignalExtraProperties(row, pdApi)
    );
    let selectedColumns: State.Column[] = [];

    selectedColumns = columns["Drive Signals"];
    const startingPage = mainState.lastEditedObjectId
      ? (driveSignalRows.findIndex(driveSignal => driveSignal.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    // Add submenu specific columns and rows
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={driveSignalRows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isDriveSignalSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditDriveSignal toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }
  /**
   * Returns status if driveSignal has been selected
   * @param {Api.AnyParameter} fault
   * @returns {boolean}
   */
  private isDriveSignalSelected = (driveSignal: Api.DriveSignal): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && driveSignal.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DriveSignalsTable;
